import React from 'react';
import Rating from '@material-ui/lab/Rating';

import { ProductReviewsDetailsType } from 'types/ProductPageV2/ProductReviews';
import { capitalize, getProductReviewsFormattedDate } from 'services/formatter';

import styles from './ProductReviewsList.module.scss';

/**
 * List of reviews contents.
 */
function ProductReviewsList({
  filter,
  reviews,
}: {
  /** Selected filter. */
  filter: number;
  /** List of reviews */
  reviews: ProductReviewsDetailsType[];
}): JSX.Element {
  let sortedData = reviews;

  switch (filter) {
    case 1:
      sortedData = reviews.sort((a, b) => {
        const dateA = new Date(a.review_date);
        const dateB = new Date(b.review_date);
        return dateB.getTime() - dateA.getTime();
      });
      break;
    case 2:
      sortedData = reviews.sort((a, b) => {
        const dateA = new Date(a.review_date);
        const dateB = new Date(b.review_date);
        return dateA.getTime() - dateB.getTime();
      });
      break;
    case 3:
      sortedData = reviews.sort((a, b) => {
        return parseInt(b.rate) - parseInt(a.rate);
      });
      break;
    case 4:
      sortedData = reviews.sort((a, b) => {
        return parseInt(a.rate) - parseInt(b.rate);
      });
      break;
    default:
      break;
  }

  return (
    <div className={styles.reviews}>
      {sortedData.map(reviewPost => {
        const {
          lastname,
          firstname,
          id_review: idReview,
          review_date: reviewDate,
          rate,
          review,
        } = reviewPost;

        return (
          <div className={styles.review} key={idReview}>
            <div className={styles.header}>
              <span>{getProductReviewsFormattedDate(reviewDate)}</span>
              <span className={styles.pipe}>|</span>
              <span>
                {capitalize(firstname)} {lastname}.
              </span>
            </div>
            <div>
              <Rating
                size={'small'}
                className={styles.stars}
                value={parseFloat(rate)}
                readOnly
              />
              <div className={styles.description}>{review}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
export default ProductReviewsList;
